
import { SMQuestionnaire } from "@/store";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { TAnswerBlock } from "../TAnswerBlocks";

@Component
export default class AnswerBlockRadio extends Vue {
  @Prop({ type: Object, default: () => ({}) }) readonly answerBlockData!: TAnswerBlock;
  @Prop({ type: Number, default: () => 0 }) readonly index: number | undefined;
  @Prop({ type: Number, default: () => 0 }) readonly loopIndex: number | undefined;

  @Watch("input")
  updateAnswer(value: string) {
    if (this.index != null)
      SMQuestionnaire.updateAnswer({
        index: this.index,
        value,
        required: this.answerBlockData.is_required,
        answer_block_id: this.answerBlockData.ID,
        answer_block_alias: this.answerBlockData.answer_block_alias,
        loop_index: this.loopIndex,
        condition: this.answerBlockData.condition,
      });
  }

  getCorrectLabel() {
    return SMQuestionnaire.currentStep?.question?.answer_blocks?.length === 1
      ? ""
      : this.answerBlockData.label;
  }

  input = "";

  created() {
    const answer = SMQuestionnaire.answers.find(
      (answer) =>
        answer.answer_block_id === this.answerBlockData.ID && this.loopIndex === answer.loop_index
    );
    if (this.index != null && answer && answer.value !== "<nil>") {
      this.input = answer.value;
    }
  }

  get errors() {
    return SMQuestionnaire.errors;
  }

  rules = [
    () => {
      const error = this.errors.find(
        (error) =>
          error.loop_index === this.loopIndex && error.answer_block_id === this.answerBlockData.ID
      );

      if (error) return error.error_message;

      return true;
    },
  ];
}
